import styled from 'styled-components'

const Container = styled.div`
  position: relative;
  margin-bottom: 1rem;
`

export { Container }
